<template>   
    <div class="whiteBG border radius chatbox right-chatBlock w-100" > 
        <complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading>
        <message-component :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message-component>
        <div v-if="ticketView != ''">
            <div class="ChatHead d-flex flex-wrap align-items-center justify-content-between p-3 mb-3">
                <div class="title"> 
                    <h3 class="mb-0"  v-if="parseInt(ticketView.ticket[0].title) !== 0"> 
                        <p v-for="list in ticketReasonList[ticketView.ticket[0].reason].categories" v-if="list.id == ticketView.ticket[0].title">{{list.title}}</p>
                    </h3>
                    <h3 class="mb-0" v-else>
                        {{ticketReasonList[ticketView.ticket[0].reason].title}}
                    </h3>
                    <p class="mb-0">{{$t('ticketNumber')}}: <strong>{{ticketView.ticket[0].ticketnumber}}</strong></p>
                    <small>{{ticketView.ticket[0].created | moment("DD MMMM")}}</small> 
                </div>
                <div class="ticketnumber_in d-flex">
                    <!-- on dev v-if="ticketView.ticket[0].reason == '97'" -->
                    <button class="btn btn-success mr-2" v-if="ticketView.ticket[0].status == 0 && ticketView.ticket[0].reason == '97'" @click="cancelwithdrawalreq(ticketView.ticket[0].ticketnumber,ticketView.ticket[0].id)">Cancel Withdrawal Request</button>
                    <router-link :to="{name: 'fxView.support' , params: { 'tabName':'openRequest'}}" class="d-flex grd_btn align-items-center"><feather type="chevron-left"></feather> {{$t('suppview_backToTicket')}}</router-link>
                </div>
            </div>
            <div class="scrollbar mid_scroll_content ticket" v-chat-scroll>
                <div class="mesgs">
                    <!-- <div class="loader" v-if="type_ticket_detail"></div> -->
                    <div class="msg_history">
                        <div class="outgoing_msg">
                            <div class="sent_msg">
								<div class="fr-view">
 
									<span class="mb-0" v-html="convertComment(ticketView.ticket[0].comment)"><span></span></span>    
								</div> 
								<span class="time_date"> {{ticketView.ticket[0].created  | moment("DD MMMM YYYY")}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="msg_history" v-for="(ticketThread,index) in ticketView.threads">
                        <div class="incoming_msg" v-if="parseInt(ticketThread.ticket_updatedby) == 1">
                            <div class="incoming_msg_img"> 
                                <img src="../../../../static/fxView/images/user-profile.svg" alt="sunil"> 
                            </div>
                            <div class="received_msg">
                                <div class="received_withd_msg">
                                    <froalaView v-model="ticketThread.message" v-if="ticketThread.message != ''"></froalaView>
                                    <div class="attached_Section" v-for="ticketThreadDoc in ticketThread.docs" :class="parseInt(ticketThreadDoc.status) == 2? 'greenClass11': parseInt(ticketThreadDoc.status) == 1? 'redClass11': 'pendingClass11'">
                                        <div class="attachedDocument">
                                            <div class="attached_msg d-flex align-items-center justify-content-between">
                                                <div class="p-0 d-flex align-items-center">
                                                    <span class="icon-tickets"><feather type="paperclip"></feather> </span> 
                                                    <p v-html="(ticketThreadDoc.document_name != undefined && ticketThreadDoc.document_name != null && ticketThreadDoc.document_name != '') ? ticketThreadDoc.document_name : ticketThreadDoc.document"></p>
                                                </div>
                                                <a :href="$env_var.docsLink+ticketView.ticket[0].user_id+'&doc='+ticketThreadDoc.document" class="contract_link icon-tickets" target="_blank()" v-if="parseInt(ticketView.ticket[0].reason) == 91 || parseInt(ticketView.ticket[0].reason) == 94 || parseInt(ticketView.ticket[0].reason) == 92">
                                                   <feather type="eye"></feather>
                                                </a>
                                                <a :href="$env_var.ticketDocsLink+ticketView.ticket[0].user_id+'&doc='+ticketThreadDoc.document" class="contract_link icon-tickets" target="_blank()" v-else>
                                                   <feather type="eye"></feather>
                                                </a>
                                            </div>
                                            <div class="DocumentStatus">
                                                <div class="ticketStatus RedBg d-flex align-items-center" v-if="parseInt(ticketThreadDoc.status) == 1">
                                                    <span class="StatusIcon redColor"><feather type="x"></feather></span>
                                                    <h4>Documents Rejected</h4>
                                                </div>
                                                <div class="ticketStatus greenBg d-flex align-items-center" v-else-if="parseInt(ticketThreadDoc.status) == 2">
                                                    <span class="StatusIcon greenColor"><feather type="check"></feather></span>
                                                    <h4>Documents Approved</h4>
                                                </div>
                                                <div class="ticketStatus YellowBg d-flex align-items-center" v-else>
                                                    <span class="StatusIcon yellowColor"><feather type="minus"></feather></span>
                                                    <h4>Documents Pending</h4>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <span class="time_date"> {{dateFunction(ticketThread.created)}}</span>
                                </div>
                            </div>
                        </div>

                        <div class="outgoing_msg" v-if="parseInt(ticketThread.ticket_updatedby) == 0">
                            <div class="sent_msg">
                                <froalaView v-model="ticketThread.message" v-if="ticketThread.message != ''"></froalaView>

                                <div class="attached_Section" v-for="ticketThreadDoc in ticketThread.docs" :class="parseInt(ticketThreadDoc.status) == 2? 'greenClass11': parseInt(ticketThreadDoc.status) == 1? 'redClass11': 'pendingClass11'">
                                    <div class="attached_msg d-flex align-items-center justify-content-between">
                                        <div class="p-0 d-flex align-items-center">
                                            <span class="icon-tickets"><feather type="paperclip"></feather> </span>
                                            <p v-html="(ticketThreadDoc.document_name != undefined && ticketThreadDoc.document_name != null && ticketThreadDoc.document_name != '') ? ticketThreadDoc.document_name : ticketThreadDoc.document"></p>
                                        </div>
                                        <a :href="$env_var.docsLink+ticketView.ticket[0].user_id+'&doc='+ticketThreadDoc.document" class="contract_link icon-tickets" target="_blank()" v-if="parseInt(ticketView.ticket[0].reason) == 91 || parseInt(ticketView.ticket[0].reason) == 92 || parseInt(ticketView.ticket[0].reason) == 94">
                                           <feather type="eye"></feather>
                                        </a>
                                        <a :href="$env_var.ticketDocsLink+ticketView.ticket[0].user_id+'&doc='+ticketThreadDoc.document" class="contract_link icon-tickets" target="_blank()" v-else>
                                           <feather type="eye"></feather>
                                        </a>
                                    </div>
                                    <div class="DocumentStatus">
                                        <div class="ticketStatus RedBg d-flex  align-items-center" v-if="parseInt(ticketThreadDoc.status) == 1">
                                            <span class="StatusIcon redColor"><feather type="x"></feather></span>
                                            <h4>Documents Rejected</h4>
                                        </div>
                                        <div class="ticketStatus greenBg d-flex align-items-center" v-else-if="parseInt(ticketThreadDoc.status) == 2">
                                            <span class="StatusIcon greenColor"><feather type="check"></feather></span>
                                            <h4>Documents Approved</h4>
                                        </div>
                                        <div class="ticketStatus YellowBg d-flex align-items-center" v-else>
                                            <span class="StatusIcon yellowColor"><feather type="minus"></feather></span>
                                            <h4>Documents Pending</h4>
                                        </div>
                                        
                                    </div>
                                </div>
                                <span class="time_date"> {{dateFunction(ticketThread.created)}}</span> 
                            </div>
                        </div> 
                    </div>




                    <!----------------------------ipv--doc-mismatch-------------------------->
                    <div class="msg_history" v-if="ipv_div != '' && parseInt(ticketView.ticket[0].status) != 3">
                        <div class="incoming_msg">
                            <div class="incoming_msg_img"> 
                                <img src="../../../../static/fxView/images/user-profile.svg" alt="sunil"> 
                            </div>
                            <div  class="received_msg">
                                <!-- <div v-if="ipv_div == '1'" class="received_withd_msg">
                                  Data Mismatch From Document <br>
                                    A problem has occurred while validating your document automatically. We have raised a ticket to resolve this. Our support team will be in touch with you as soon as possible, and within 2 Business days
                                </div> -->
                                <div v-if="ipv_div == '2'" class="received_withd_msg">
                                    {{$t('suppview_thankyou')}} <br>
                                    <router-link :to="'/create-live-account'">{{$t('suppview_createliveAcc')}}</router-link>
                                </div>
                                <div v-if="ipv_div == '3'" class="received_withd_msg">
                                    
                                        <p  v-show="addressMatched == 1 && idMatched == 1">{{$t('suppview_whilevalidate1')}}</p>

                                        <p  v-show="addressMatched == 1 && idMatched != 1">{{$t('suppview_whilevalidate2')}}</p>

                                        <p  v-show="addressMatched != 1 && idMatched == 1">{{$t('suppview_whilevalidate3')}}</p>
                                    
                                    <div class="px-5 mb-3 received_withd_msg"> 
                                        <div class="col-12" v-show="showArr[currentStep] == 'address'">
                                            <small class="subtitle">{{$t('suppview_originalAdress')}} <address> {{get_user.profile.address1}} {{get_user.profile.address2}} <br>  {{get_user.profile.city}} <br> {{get_user.profile.post_code}} <br><p v-for="clist in countriesList" v-if="clist.id == get_user.profile.residence_country">{{clist.name}}</p>  </address></small>
                                            <ul class="twoColumn">
                                                <li v-for="addressDocument, index in addressFromDocument">    
                                                    <label class="customRadio-button"><address>{{addressDocument.subStreetEn}}  {{addressDocument.streetEn}} <br> {{addressDocument.townEn}} <br>{{addressDocument.postCode}}</address>
                                                        <input type="radio" class="form-control" v-model="selected_address_type" :value="addressDocument" :id="'checkbox_id'+index">
                                                        <span class="checkmark"></span>
                                                    </label>
                                                </li>
                                                <li >    
                                                    <label class="customRadio-button">{{$t('suppview_stepMsz18')}} 
                                                        <input type="radio" class="form-control" v-model="selected_address_type" value="-1" id="dontwanttochangeAddress">
                                                        <span class="checkmark"></span>
                                                    </label>
                                                </li>
                                            </ul>
                                            <div class="row">
                                                <div class="col-12">
                                                    <div class="full-width border-top pt-3 submitButton align-items-center d-flex spacebetween mt-3 w-100">
                                                        <div class="leftbtn">
                                                            <button class="prism_btn btn_sm grayBtn" v-if="currentStep!=0" v-on:click.prevent="currentStep--">{{$t('suppview_preQues')}}</button>
                                                        </div> 
                                                        <button class="prism_btn btn_sm" v-on:click.prevent="currentStep++" v-if="parseInt(currentStep) != showArr.length-1">{{$t('suppview_nextQues')}}</button> 
                                                        <button class="prism_btn btn_sm" v-on:click.prevent="resolveConflict()" v-else>{{$t('suppview_stepMsz21')}} </button>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                        </div> 

                                        <div class="col-12" v-show="showArr[currentStep] == 'nationalid'">
                                            <h6 class="subtitle">{{$t('suppview_idNumEnt')}} {{get_user.profile.P_IDNUMBER}}</h6>
                                            <ul class="twoColumn">
                                                <li v-for="(idNumberDocument, index) in idNumberFromDocument" v-if="'number' in idNumberDocument">   
                                                    <label class="customRadio-button">
                                                        <address>{{idNumberDocument.number}}</address>
                                                        <input type="radio" class="form-control" v-model="selected_id_type" :value="idNumberDocument.number" :id="'checkbox'+index">
                                                        <span class="checkmark"></span>
                                                    </label>
                                                </li>
                                                <li v-for="(idNumberDocument, index) in idNumberFromDocument" v-if="'additionalNumber' in idNumberDocument">   
                                                    <label class="customRadio-button">
                                                        <address>{{idNumberDocument.additionalNumber}}</address>
                                                        <input type="radio" class="form-control" v-model="selected_id_type" :value="idNumberDocument.additionalNumber" :id="'checkbox'+index">
                                                        <span class="checkmark"></span>
                                                    </label>
                                                </li>
                                                <li>    
                                                    <label class="customRadio-button">{{$t('suppview_stepMsz18')}}
                                                        <input type="radio" class="form-control" v-model="selected_id_type" value="-1" id="dontwanttochange">
                                                        <span class="checkmark"></span>
                                                    </label>
                                                </li>
                                            </ul>
                                            <div class="row">
                                                <div class="quesPercntBar col-12 mb-3" v-show="false">
                                                    <span>0 {{$t('suppview_percentComplete')}}</span>
                                                    <div class="progressBar progress">
                                                         <div class="progress-bar" role="progressbar"  aria-valuenow="15" aria-valuemin="0" aria-valuemax="100"></div>
                                                    </div>
                                                </div>
                                                <div class="col-12">
                                                    <div class="full-width border-top pt-3 submitButton align-items-center d-flex spacebetween mt-3 w-100">
                                                        <div class="leftbtn">
                                                            <button class="prism_btn btn_sm grayBtn" v-if="currentStep!=0" v-on:click.prevent="currentStep--">{{$t('suppview_preQues')}}</button>
                                                        </div> 
                                                        <button class="prism_btn btn_sm" v-on:click.prevent="currentStep++" v-if="parseInt(currentStep) != showArr.length-1">{{$t('suppview_nextQues')}}</button> 
                                                        <button class="prism_btn btn_sm" v-on:click.prevent="resolveConflict()" v-else>{{$t('suppview_stepMsz21')}} </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div> 

                                        <div class="col-12" v-show="showArr[currentStep] == 'personal_info'">
                                            <h6 class="subtitle">Name: {{get_user.profile.firstname}}{{get_user.profile.lastname}}</h6>
                                            <ul class="twoColumn">

                                                <li v-if="perosnalInfoFromDocument">   
                                                    <label class="customRadio-button">
                                                        <address>{{perosnalInfoFromDocument.firstname}}  {{perosnalInfoFromDocument.lastname}}</address>
                                                        <input type="radio" class="form-control" v-model="selected_personal_info_type" :value="perosnalInfoFromDocument.firstname + ' ^^ '+ perosnalInfoFromDocument.lastname" :id="'checkbox'+index">
                                                        <span class="checkmark"></span>
                                                    </label>
                                                </li>
                                                
                                                <li>    
                                                    <label class="customRadio-button">{{$t('suppview_stepMsz18')}}
                                                        <input type="radio" class="form-control" v-model="selected_personal_info_type" value="-1" id="dontwanttochange">
                                                        <span class="checkmark"></span>
                                                    </label>
                                                </li>
                                            </ul>
                                            <div class="row">
                                                <div class="quesPercntBar col-12 mb-3" v-show="false">
                                                    <span>0 {{$t('suppview_percentComplete')}}</span>
                                                    <div class="progressBar progress">
                                                         <div class="progress-bar" role="progressbar"  aria-valuenow="15" aria-valuemin="0" aria-valuemax="100"></div>
                                                    </div>
                                                </div>
                                                <div class="col-12">
                                                    <div class="full-width border-top pt-3 submitButton align-items-center d-flex spacebetween mt-3 w-100">
                                                        <div class="leftbtn">
                                                            <button class="prism_btn btn_sm grayBtn" v-if="currentStep!=0" v-on:click.prevent="currentStep--">{{$t('suppview_preQues')}}</button>
                                                        </div> 
                                                        <button class="prism_btn btn_sm" v-on:click.prevent="currentStep++" v-if="parseInt(currentStep) != showArr.length-1">{{$t('suppview_nextQues')}}</button> 
                                                        <button class="prism_btn btn_sm" v-on:click.prevent="resolveConflict()" v-else>{{$t('suppview_stepMsz21')}} </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div> 

                                        <div class="col-12" v-show="showArr[currentStep] == 'nationality'">
                                            <h6 class="subtitle">{{$t('suppview_nationalityEntered')}} <p for="checkbox_id" v-for="list in countriesList" v-if="list.iso2.toUpperCase() == get_user.profile.residence_country.toUpperCase()"> {{list.name}}</p></h6>
                                            <ul class="twoColumn">
                                                <li v-for="(idNumberDocument, index) in idNumberFromDocument" v-if="'number' in idNumberDocument">    
                                                    <label class="customRadio-button">
                                                        
                                                        <p for="checkbox_id" v-for="list in countriesList" v-if="list.iso2.toUpperCase() == idNumberDocument.country.substr(0,2).toUpperCase()"> 
                                                            {{list.name}}
                                                        </p>

                                                        <input type="radio" class="form-control" v-model="selected_nationality" :value="idNumberDocument.country.substr(0,2).toUpperCase()" :id="'checkbox'+index">
                                                        <span class="checkmark"></span>
                                                    </label>
                                                </li>
                                                <li>    
                                                    <label class="customRadio-button" for="dontwanttochangeNationality">{{$t('suppview_stepMsz18')}}
                                                        <input type="radio" class="form-control" v-model="selected_nationality" value="-1" id="dontwanttochangeNationality">
                                                        <span class="checkmark"></span>
                                                    </label>
                                                </li>
                                            </ul>
                                            <div class="row">
                                                <div class="col-12">
                                                    <div class="full-width border-top pt-3 submitButton align-items-center d-flex spacebetween mt-3 w-100">
                                                        <div class="leftbtn">

                                                            <button class="prism_btn btn_sm grayBtn" v-if="currentStep!=0" v-on:click.prevent="currentStep--">{{$t('suppview_preQues')}}</button>
                                                        </div> 
                                                        <button class="prism_btn btn_sm" v-on:click.prevent="currentStep++" v-if="parseInt(currentStep) != showArr.length-1">{{$t('suppview_nextQues')}}</button> 
                                                        <button class="prism_btn btn_sm" v-on:click.prevent="resolveConflict()" v-else>{{$t('suppview_stepMsz21')}} </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div> 
                                        
                                    </div> 
                                </div>
                            </div>
                        </div>
                    </div>
                    <!----------------------------------------------------------------------->
                </div>
            </div>

            <div class="type_msg" v-if="ticketView.ticket && parseInt(ticketView.ticket[0].status) != 3">
                <form action="" method="post" enctype="multipart/form-data" id="TicketReplyForm" v-on:submit.prevent="submitNow()">
                    <div class="input_msg_write d-flex justify-content-between align-items-center position-relative">
                        <!--Static Upload Design-->
                        <div class="showOnclick gooeyMenu" v-if="parseInt(ticketView.ticket[0].reason) == 91"> 
                        
                            <div class="uploadShowMenu" :class="setUpFxaccount?'active':' '">
                                <ul class="listAnimated setUpFxaccount">
                                    <li class="bt1" v-for="val in fileNames" >  
                                        <div class="sptIcon">
                                            <feather size="16px" type="upload"></feather>
                                        </div>
                                        <div class="upload-btn-wrapper" @click.prevent="docType = val; $refs.file.click()" >
                                              <a class="btn"  href="#" @click.prevent="docType = val">{{val.value}}</a>
                                        </div>
                                    </li>
                                    
                                </ul>   
                            </div>
                        </div>
                        
                        <div class="upload-btn-wrapper mr-2" v-else>
                            <div class="d-flex align-items-center"  @click.prevent="$refs.file.click()">
                                <feather type="paperclip" class="mr-1"></feather> 
                            </div>
                        </div>
                        
                        <div class="upload-btn-wrapper mr-2 d-none" >
                            <input type="file" name="document[]" id="docfile" ref="file" @change="onFileChange($event.target.name, $event.target.files)" v-validate="{required: (text == '')}"/> 
                        </div>
                        
                        
                        <!--Static Upload Design-->
                        <div class="showDocument" v-if="document != ''">
                            <div class="showDocument-group">
                                <div class="ftIco">
                                    <feather type="file"></feather>
                                </div>
                                <p class="m-0">{{document}} <feather class="closeIt" type="x" @click.prevent="clear_doc()"></feather>
                                </p>
                                <span class="sizeSM">2.14kb</span>
                            </div>
                        </div>
                        
                        
                        
                        <span class="alert alert-danger position-absolute erroMT" v-if="submitted && (errors.has('document[]') ||  errors.has('message'))">{{$t('suppview_fillone')}}</span>
                        <input type="hidden" name="ticket_id" :value="ticketView.ticket[0].id">
                    
                        <textarea class="write_msg" placeholder="Type a message" v-model="text" name="message" v-validate="{required: errors.has('document[]')}"></textarea>
                        <div class="input_msg_write_btn d-flex align-items-center" >
                            <div class="uploadGooey setUpFxaccount" :class="setUpFxaccount?'active':' '" v-if="parseInt(ticketView.ticket[0].reason) == 91">   
                                <a @click.prevent="setUpFxaccount = !setUpFxaccount" href="#">
                                    <feather class="addIB" type="plus"></feather> 
                                    <feather class="closeIB" type="x"></feather> 
                                </a>
                            </div>
                            <button class="msg_send_btn" :class="[(text == '' && document == '')?'disabled' : '',{'disabled' : pageLoader }]"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="currentColor" d="M1.101 21.757L23.8 12.028 1.101 2.3l.011 7.912 13.623 1.816-13.623 1.817-.011 7.912z"></path></svg></button>
                        </div>
                    </div>
                    <!-- <span class="text-danger bottmErro" v-if="submitted && errors.has('message')">{{ errors.first('message') }}</span> -->
                </form> 
            </div>
            <!-- <div class="type_msg" v-if="parseInt(ticketView.ticket[0].status) != 3">
                <form action="" method="post" enctype="multipart/form-data" id="TicketReplyForm" v-on:submit.prevent="submitNow()" >
                    <div class="input_msg_write d-flex justify-content-between align-items-center">
                        <textarea class="write_msg" :placeholder="$t('TypeMsz')" v-model="text" name="message"></textarea> 
                        <div class="input_msg_write_btn d-flex align-items-center">
                            <div class="upload-btn-wrapper pr-2">
                                <div class="btn roundedPLuse d-flex align-items-center"  @click.prevent="$refs.file.click()" v-if="rest.length == 0">
                                    <feather type="plus"></feather> 
                                    
                                </div> 
                                <input class="inputfile-1 form-control"  type="file"  name="document[]" value="Upload Document" id="file" ref="file" v-on:change="onFileChange($event)" >
                            </div>
                            
                        </div>
                        <div class="showDocument d-flex align-items-center flex-wrap" v-if="rest.length > 0">
                            <div class="d-flex align-items-center flex-wrap">
                                <div class="showDocument-group repeateUpload" v-for="(value,index) in rest">
                                    <div class="ftIco"><feather size="16px" type="file"></feather></div> 
                                    <p class="m-0">{{value.name}} <feather type="x" class="closeIt" @click.prevent="remove(index)"></feather> </p> 
                                     <span class="sizeSM">{{value.size/1000}}kb</span> 
                                </div>
                               
                            </div>
                        </div>
                        <button class="msg_send_btn" type="submit" :class="(text != '' || rest.length > 0 )?'' :'disabled'">{{$t('send')}}</button>
                    </div> 
                </form> 
            </div> -->
        </div>
    </div> 
</template>
<script> 
    import { fxViewMixins } from '@/plugins/fxView'  
    import * as types from '@/types'
    import { mapActions } from 'vuex'
    import moment from 'moment'
    export default {
        name: 'View-TICKET',
        mixins: [fxViewMixins],
        data () {
            return {
                //============message and loader ===========
                response_msg : '',
                msg_type : '',
                pageLoader : false,
                type_ticket_detail : false,
                loaderFuncRun : '1',
                //update_id : '',
                //==========================================
            
                submitted : false,
                text : '', 
                config: {
                    placeholder: "Edit Me",
                    key: 'ERB2zH3C1A8A2B2A1qYFd1UQRFQIVb1MSMc2IWPNe1IFg1yD4C3D2D2C4C1G1H4B1C1=='
                },
                rest : [],


                //=====================ipv=============================
                ipv_div : '',
                
                showArr: [],
                currentStep:0,

                addressFromDocument:'',
                addressMatched: 2,

                perosnalInfoMatched: 2,
                selected_address_type: '',
                perosnalInfoFromDocument: '',

                idNumberFromDocument:'',
                idMatched: 2,
                selected_id_type: '',

                nationalityFromDocument: '',
                nationalityMatched: 2,
                selected_nationality:'',

                setUpFxaccount : false,
                document : '',
                fileNames:[
                    { name:'Passport',value:'Passport',type:'Proof_of_Identity'},
                    { name:'Drivers_License_BACK',value:'Drivers License Back',type:'Proof_of_Identity'},
                    { name:'Drivers_License_FRONT',value:'Drivers License Front',type:'Proof_of_Identity'},
                    { name:'Government_Issued_Photo_ID_BACK',value:'Government Issued Photo ID Back',type:'Proof_of_Identity'},
                    { name:'Government_Issued_Photo_ID_FRONT',value:'Government Issued Photo ID Front',type:'Proof_of_Identity'},
                    { name:'Bank_Credit_Card_Statement',value:'Bank Statement/Credit Card Statement',type:'Proof_of_Residence'},
                    { name:'Utility_Bill',value:'Utility Bill',type:'Proof_of_Residence'},
                    { name:'Payroll_Statement',value:'Payroll Statement',type:'Proof_of_Residence'},
                    { name:'Tax_Document',value:'Tax Document',type:'Proof_of_Residence'},
                    { name:'Photo_Verification',value:'Liveness/Selfie',type:'Photo_Verification'}
                ],
                invidual_file:{},
                docType : ''
            }
        },
        props:['ticketId'],
        methods:{
            //cancel withdrawal request
            cancelwithdrawalreq(ticket, ticket_id){
                let input_json={
                    'globalParams' :{
                        'ticket' : ticket,
                        'ticket_id' : ticket_id
                    },
                    'localParams' :{ "parameter" : this}
                }
                this._runCancelWithdrawalRequest(input_json)
            },
            convertComment(comment){
                if(comment.includes('&lt;br&gt;')){
                   let com = comment.replace(/&lt;br&gt;/g,' <br>');
                    return com
                }else{
                    return comment
                }
            },
             clear_doc(){
                this.document = ''
                document.getElementById('docfile').value = ''
            },
            clear(){
                this.document = ''
                document.getElementById('docfile').value = ''
            
                this.invidual_file = {};
                this.text = ''
                this.docType = ''
                this.setUpFxaccount = false
                this.submitted = false
            },
    //         clear(){
    //             this.document = ''
    //             this.text = ''
				// document.getElementById('file').value = '' 
    //             this.rest = []
    //             this.submitted = false
    //         },
            dateFunction(getDate){
                let last_seen_date = moment(getDate).fromNow();
                return last_seen_date;
            },
            ticketDetail(){
                console.log(this.$route.query, "=====>this.$route.query.id")
                let input_json={
                    'globalParams' :{
                        'ticket_id' : (this.ticketId != undefined && this.ticketId != null && this.ticketId != '')? this.ticketId : this.$route.query.id
                    },
                    'localParams' :{ "parameter" : this}
                }
                this._runGetTicketDetail(input_json)
            },
            // onFileChange(event) {
            //      this.rest.push({
            //         name: event.target.files[0].name,
            //         file: event.target.files[0],
            //         size : event.target.files[0].size
            //      })
            // },
            onFileChange(fieldName, file) {
                this.document = file[0].name,
                this.setUpFxaccount = false
                if(parseInt(this.ticketView.ticket[0].reason) == 91 ){
                    this.invidual_file['file'] = file[0];
                    this.invidual_file['name'] = file[0].name;
                }
            },
    //         remove(getindex){
				// document.getElementById('file').value = '' 
    //             this.rest= this.rest.filter( (value,index) => index != getindex )
    //         },
            submitNow(){
               
                const _that = this
                _that.submitted = true;
                _that.$validator.validate().then(valid => {
                    if (valid) {  
                        let TicketReplyForm = document.getElementById('TicketReplyForm');
                        let form_name = new FormData(TicketReplyForm);
                        
                        if(parseInt(_that.ticketView.ticket[0].reason) == 91 && this.document != ''){
                            form_name = new FormData();
                            
                            form_name.append('document[]', _that.invidual_file.file, _that.docType.name+ '.'+ _that.invidual_file.name.split('.')[_that.invidual_file.name.split('.').length -1] );
                            
                            form_name.append('documenttype', _that.docType.type);
                            form_name.append('message', _that.text);
                            form_name.append('ticket_id', _that.ticketView.ticket[0].id);
                        }
                        if((parseInt(_that.ticketView.ticket[0].reason) == 91 || parseInt(_that.ticketView.ticket[0].reason) == 92) && this.document != ''){
                            form_name.append("type", 'user');
                        }
                        
                        let input_json =  {
                            'globalParams' :{
                                "form" : form_name
                            },
                            'localParams' :{ "parameter" : _that ,'type' :'form','tick_id' : _that.ticketView.ticket[0].id }
                        };
                        // console.log(input_json)
                        _that._runTicketReply(input_json)
                    }
                });
            },
    //         submitNow(){
    //             const _that = this
				// if((_that.text != '') || (_that.rest.length > 0 )){
				// 	let form_name = '';
				// 	var address_length = 0
				// 	if(_that.rest.length > 0){
				// 		form_name = new FormData();
				// 		_that.rest.forEach(value => {
				// 			if(value.name != ''){
				// 				address_length += 1
				// 				form_name.append('document[]', value.file);
				// 			}
				// 		});
				// 		form_name.append("message", _that.text);
				// 		if(parseInt(_that.ticketView.ticket[0].reason) == 91 || parseInt(_that.ticketView.ticket[0].reason) == 92){
				// 			form_name.append("type", 'user');
				// 		}
				// 	}else{
				// 		let formRequest = document.getElementById('TicketReplyForm');
    //                     form_name = new FormData(formRequest);
				// 	}
				// 	form_name.append("ticket_id", _that.ticketView.ticket[0].id);
					
					
				// 	let input_json={
				// 		'globalParams' :{
				// 			'form' : form_name
				// 		},
				// 		'localParams' :{ "parameter" : _that ,"module" : 'ticket-reply','tick_id' : this.ticketView.ticket[0].id  }
				// 	}
				// 	_that._runTicketReply(input_json)
				// }
    //         },



            //=================ipv document========================================
            ...mapActions({
                _runGetResolveDocIssue: types.RUN_RESOLVE_DOC_ISSUE
            }),
            subSubResp(responseFromSumSub){
                if(responseFromSumSub!=''){
                    if(parseInt(responseFromSumSub.resolved) == 1){
                        this.ipv_div = '1'
                    }else{
                        if(parseInt(responseFromSumSub.overallstatus) == 2){
                            const sumsubResp = JSON.parse(responseFromSumSub.sumsubresp)
                            if(responseFromSumSub.suspicionReasons == '"PROBLEMATIC_APPLICANT_DATA"' && sumsubResp.reviewResult.reviewRejectType == 'RETRY'){
                                this.ipv_div = '1'
                            }

                            if(sumsubResp.reviewResult.reviewRejectType == 'FINAL'){
                                this.ipv_div = '1'
                            }
                        }

                        if(parseInt(responseFromSumSub.overallstatus) == 1){
                           this.ipv_div = '2'
                        }

                        if(parseInt(responseFromSumSub.overallstatus) == 0){
                            // sumsubaddress
                            const sumSubAddress = JSON.parse(responseFromSumSub.sumsubaddress)
                            // let addressFound = 0
                            if(sumSubAddress.status == 1){
                                this.addressMatched = 0
                            }else{
                                this.showArr.push('address')
                                this.ipv_div = '3'
                                this.addressFromDocument = sumSubAddress.address
                                this.addressMatched = 1
                            }
                        
                            const sumSubIdNumber = JSON.parse(responseFromSumSub.idnumber)

                            if(sumSubIdNumber.status == 1){
                                this.idMatched = 0
                            }

                            else{
                                this.showArr.push('nationalid')
                                this.ipv_div = '3'
                                this.idNumberFromDocument = sumSubIdNumber.idnumber
                                this.iframeVar = false
                                this.idMatched = 1
                            }

                            const sumSubperosnalInfo = JSON.parse(responseFromSumSub.personal_info)

                            if(sumSubperosnalInfo.status == 1){
                                this.perosnalInfoMatched = 0
                            }else{
                                this.showArr.push('personal_info')
                                this.ipv_div = '3'
                                this.perosnalInfoFromDocument = sumSubperosnalInfo
                                this.iframeVar = false
                                this.perosnalInfoMatched = 1
                            }
                            
                            const nationalityRespS = JSON.parse(responseFromSumSub.nationalityResp)

                            // if(nationalityRespS.status == 1){
                                this.nationalityMatched = 0
                            // }
                            // else{
                            //     this.showArr.push('nationality')
                            //     this.ipv_div = '3'
                            //     this.nationalityFromDocument = nationalityRespS.idnumber
                            //     this.nationalityMatched = 1
                            // }
                        }
                    }
                }
            },
            resolveConflict(){
                let overallStatus = 1

                if(this.idMatched == 1 && this.selected_id_type == -1){
                    overallStatus= 0
                }
                if(this.addressMatched == 1 && this.selected_address_type == -1){
                    overallStatus = 0
                }
                if(this.nationalityMatched == 1 && this.selected_nationality == -1){
                    overallStatus = 0
                }
                if(this.perosnalInfoMatched == 1 && this.selected_personal_info_type == -1){
                    overallStatus = 0
                }



                


                let formatAddress = {}
                if(this.addressMatched == 1 && this.selected_address_type != -1){
                    formatAddress.address1 = this.selected_address_type.subStreetEn.trim() +" "+this.selected_address_type.streetEn.trim()
                    formatAddress.city = this.selected_address_type.townEn.trim()
                    formatAddress.post_code = this.selected_address_type.postCode.trim()
                    formatAddress.residence_country = this.selected_address_type.country.substr(0,2)
                }

                let globalParameter = {}

                if(this.addressMatched == 1 && this.selected_address_type != -1){

                    globalParameter.addressNotChanged = 0
                    globalParameter.address = formatAddress
                }

                if(this.addressMatched == 1 && this.selected_address_type == -1){
                    globalParameter.addressNotChanged = 1
                    globalParameter.address = this.addressFromDocument
                }

                if(this.idMatched== 1 && this.selected_id_type != -1){
                    globalParameter.IdNotChanged = 0
                    globalParameter.idnumber = this.selected_id_type
                }

                if(this.idMatched== 1 && this.selected_id_type == -1){
                    globalParameter.IdNotChanged = 1
                    globalParameter.idnumber = this.idNumberFromDocument
                }

                if(this.nationalityMatched== 1 && this.selected_nationality != -1){
                    globalParameter.nationalityNotChanged = 0
                    globalParameter.nationality = this.selected_nationality
                }

                if(this.nationalityMatched== 1 && this.selected_nationality == -1){
                    globalParameter.nationalityNotChanged = 1
                    globalParameter.nationality = this.idNumberFromDocument
                }

                 if(this.perosnalInfoMatched== 1 && this.selected_personal_info_type != -1){
                    globalParameter.perosnalInfoNotChanged = 0
                    globalParameter.username = this.selected_personal_info_type
                }

                if(this.perosnalInfoMatched== 1 && this.selected_personal_info_type == -1){
                    globalParameter.perosnalInfoNotChanged = 1
                    globalParameter.username = this.perosnalInfoFromDocument
                }

                globalParameter.overallStatus  = overallStatus
                const _that = this
                let input_json = {
                    'globalParams' : globalParameter,
                    'localParams' :{
                        "parameter" : _that
                    }
                };
                _that._runGetResolveDocIssue(input_json)
            },
            //=====================================================================
        },
        created(){
            this.ticketDetail()
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/supports/view.vue